import { useGetUserArticlePoaTimePoints } from '../Navbar/hooks/useGetUserArticlePoaTimePoints';
import NavbarTimePointsLabel from '../Navbar/NavbarTimePointsLabel';
import { usePromptPageContext } from '../Prompt/context/PromptPageContext';
import { useAuthenticatedUser } from '../Auth/hooks/useAuthenticatedUser';

export const PromptReplyPreviewTimepoints = () => {
  const { isAuthenticated } = useAuthenticatedUser();
  const { preview } = usePromptPageContext();
  const { userArticleTimePoints: timePoints } = useGetUserArticlePoaTimePoints({
    articleId: preview.state.articleId || '',
    pollInterval: 60000,
    skip: !isAuthenticated || !preview.state.articleId,
  });

  if (!isAuthenticated) {
    return null;
  }
  return <NavbarTimePointsLabel isAuthenticated userArticleTimePoints={timePoints} />;
};
